import React, { useEffect, useState } from "react";
import { CommonPageHeading } from "../../../CommonUtilities/CommonHeading/CommonPageHeading";
import PublicHeader from "../../../Header/PublicHeader";
import { Col, Row, Tab, Tabs } from "react-bootstrap";
import { config } from "../../../CommonUtilities/CommonUrl/CommonUrls";
import axios from "axios";
import Sweetalert from "../../../CommonUtilities/CommonPopupAndAlerts/SweetAlerts";
import { viewImage } from "../../../CommonUtilities/CommonFileUpload/ViewImage";
import { FaHandPointRight } from "react-icons/fa";
import { CURRENT_ACADEMIC_YEAR } from "../../../CommonUtilities/Validations/RegularExpAndVar";

export default function SelectionList() {
  const[status,setStatus]=useState()
  const [currentTab, setCurrentTab] = useState();
  const [tabs, setTabs] = useState([]);
  const [orderData, setorderData] = useState([]);
  const [filteredOrderData, setfilteredOrderData] = useState([]);

  const handleTabClick = (event) => {
    let evnt = parseInt(event);
    setCurrentTab(evnt);
    let fdata = orderData?.filter(
      (val) => val?.management_code === parseInt(evnt)
    );
    setfilteredOrderData(fdata);
  };

  function getDataFunctionResult() {
    const url = `${config.url.DSC_Read_URL}dsc-public/get-provisional-selection-list`;
    axios.get(url).then((response) => {
      if (response?.data?.status === true) {
        setStatus(true);
        const posts = response?.data?.data;
        let tab = [
          ...new Map(
            posts?.map((item) => [
              item.management_code,
              {
                key: item?.management_code,
                name: item?.management_short_name,
                management : item?.management,
                dist_zone_state:item?.dist_zone_state,
              },
            ])
          ).values(),
        ];
        setTabs(tab);
        setorderData(posts);
      } else {
         setStatus(false);
        setorderData([]);
      }
    });
  }

  useEffect(() => {
    getDataFunctionResult();
  }, []);

  // set first tab automatically when tabs are ready
  useEffect(() => {
    if (tabs.length > 0 && orderData?.length > 0) {
      setCurrentTab(tabs[0].key);
      const result = orderData.filter(
        (item) => item.management_code === tabs[0].key
      );
      setfilteredOrderData(result);
    }
  }, [tabs, orderData]);

  const renderTabContent = (phasefilData,ev) => {
    return (
      <>
        {phasefilData?.length > 0 ? (
          <div className="mt-2">
            <div className="table-responsive">
              <table
                role="presentation"
                className="table table-bordered table-responsive table-college mt-0"
                style={{
                  border: "1",
                  width: "100%",
                  borderCollapse: "collapse",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                //   fontSize: "12px",
                }}
                id="table-to-xls"
              >
                <thead>
                  <tr
                    className="text-center"
                    style={{ backgroundColor: "beige", color: "brown" }}
                  >
                    <th colSpan={13}>AP DSC -{CURRENT_ACADEMIC_YEAR} Selection List - <font color="tomato">{tabs?.filter((val)=>val?.key === parseInt(ev))[0]?.management} </font></th>
                  </tr>
                  <tr>
                    <td>S.No.</td>
                    <td>Post</td>
                    <td>State/Zone/District</td>
                    <td>Action</td>
                  </tr>
                </thead>
                <tbody>
                  {phasefilData?.map((row, index) => (
                    <tr key={index}>
                      <td>{index + 1}.</td>
                      <th>{row?.post_name}</th>
                      <th>{row?.dist_zone_state}</th>
                      <td><button button type='button' className='button-30' onClick={() => {
                   // if (row?.esign_filepath) {
                       viewImage(row?.esign_filepath)
                                                              // } else {
                                                              //     Sweetalert('Coming Soon !!...', 'warning')
                                                              // }
                      
                      }}><FaHandPointRight />&nbsp;Click Here</button></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        ):<div className="text-center mt-4">***<img src="images1/comming_soon.jpg" className="img-fulid"/> ***</div>}
      </>
    );
  };

  return (
    <React.Fragment>
      <PublicHeader />
      <div className="mt-5 px-2 pt-2">
        <CommonPageHeading
          heading="AP DSC -2025 Selection List"
          back={true}
        />
        <div className="jnb-tabs">
      {(tabs?.length>0 && status === true)?
          <Tabs
            activeKey={currentTab}
            onSelect={(event) => handleTabClick(event)}
            id="controlled-tab-example"
          >
            {tabs?.map((t) => (
              <Tab
                key={t?.key}
                eventKey={t?.key}
                title={
        <div className="text-center" style={{ width: "90px" }}> {/* fixed width */}
          {t.icons} {t.name}
        </div>
      }>{t?.key === currentTab &&
                  renderTabContent(filteredOrderData,t?.key)}
              </Tab>
            ))}
          </Tabs>
        :status === false?<div className="text-center mt-4">***<img src="images1/comming_soon.jpg" className="img-fulid"/> ***</div>:""}
        </div>
      </div>
    </React.Fragment>
  );
}
